const LOGOS = {
  mark: { src: "/brand/logo-mark.webp", ratio: "aspect-[720/256]" },
  full: { src: "/brand/logo-full.webp", ratio: "aspect-[1200/283]" },
};

// SPC brand logo (supplied artwork) used as a CSS mask so it takes the current text colour in light and dark mode.
export const Logo = ({ className = "", variant = "mark" }) => {
  const { src, ratio } = LOGOS[variant];
  const mask = `url(${src})`;
  return (
    <span
      role="img"
      aria-label="SPC"
      className={`block bg-current ${ratio} ${className}`}
      style={{
        WebkitMaskImage: mask,
        maskImage: mask,
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "left center",
        maskPosition: "left center",
      }}
      data-testid={`spc-logo-${variant}`}
    />
  );
};
